export const styles = {
  small: 'ScrollableList_small',
  medium: 'ScrollableList_medium',
  big: 'ScrollableList_big',
  full: 'ScrollableList_full',
} as const
